<div class="mx-auto max-w-(--breakpoint-2xl)">
  <div class="w-full">
    <div class="my-10 text-center">
      <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
        @if (user.id) {
          Edit Contact
        } @else {
          Add Contact
        }
      </h2>
    </div>
  </div>

  <form [formGroup]="form">

    <div class="flex gap-3 items-start">
      <div class="w-full">

        <div class="mb-3 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

          <div class="px-5 py-4 sm:px-6 sm:py-5">
            <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
              Contact Information
            </h3>
          </div>
          <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
            <div class="-mx-2.5 flex flex-wrap gap-y-5">
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'User Name'" [label]="'Name'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.email" [type]="'email'" [name]="'email'" [placeholder]="'user@example.com'" [label]="'Email'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.second_email" [type]="'email'" [name]="'email'" [placeholder]="'user@example.com'" [label]="'Second Email'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/2">
                <app-text-input [control]="form.controls.password" [type]="'password'" [name]="'password'" [placeholder]="'***'" [label]="'Password'"></app-text-input>
              </div>
              <div class="w-full px-2.5">
                <h4 class="mb-2 text-sm font-medium text-gray-700 dark:text-gray-400">Address</h4>
              </div>
              <div class="w-full px-2.5">
                <app-text-input [control]="form.controls.address_line_1" [type]="'text'" [name]="'address_line_1'" [placeholder]="'Address Line 1'" [label]="'Address Line 1'"></app-text-input>
              </div>
              <div class="w-full px-2.5">
                <app-text-input [control]="form.controls.address_line_2" [type]="'text'" [name]="'address_line_2'" [placeholder]="'Address Line 2 (optional)'" [label]="'Address Line 2'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/3">
                <app-text-input [control]="form.controls.city" [type]="'text'" [name]="'city'" [placeholder]="'City'" [label]="'City'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/3">
                <app-text-input [control]="form.controls.postcode" [type]="'text'" [name]="'postcode'" [placeholder]="'Postcode'" [label]="'Postcode'"></app-text-input>
              </div>
              <div class="w-full px-2.5 xl:w-1/3">
                <app-text-input [control]="form.controls.country" [type]="'text'" [name]="'country'" [placeholder]="'Country'" [label]="'Country'"></app-text-input>
              </div>

              <div class="w-full px-2.5 xl:w-1/2">
                <app-select [control]="form.controls.contact_status" [choices]="contactStatusChoices" label="Status" [searchable]="true"></app-select>
              </div>
<!--              <div class="w-full px-2.5 xl:w-1/2">-->
<!--                <app-select [control]="form.controls.event_ids" [multiple]="true" [choices]="eventsChoices$" label="Events" [searchable]="true"></app-select>-->
<!--              </div>-->
              <div class="w-full px-2.5 xl:w-1/2">
                <app-array-input [formArray]="form.controls.phone_numbers" [type]="'text'" [name]="'phone_numbers'" [label]="'Phone Number'"></app-array-input>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes Section -->
        @if (user.id) {
          <div class="mb-3 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
              <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
                Notes
              </h3>
            </div>
            <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
              @if (user.notes && user.notes.length > 0) {
                <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
                  <table class="min-w-full">
                    <thead class="border-t border-gray-100 dark:border-gray-800">
                    <tr>
                      <th class="w-[20%] border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                        <div class="flex items-center justify-between"><p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Created</p></div>
                      </th>
                      <th class="border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                        <div class="flex items-center justify-between"><p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Note</p></div>
                      </th>
                      <th class="w-[5%] border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                        <div class="flex items-center justify-between"><p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Edit</p></div>
                      </th>
                      <th class="w-[5%] border-r border-gray-200 px-4 py-3 dark:border-gray-800">
                        <div class="flex items-center justify-between"><p class="text-theme-xs font-medium text-gray-700 dark:text-gray-400">Delete</p></div>
                      </th>
                    </thead>
                    <tbody>
                      @for (note of user.notes; track note.id) {
                        <tr class="h-12 odd:bg-gray-50 even:bg-white hover:bg-gray-100 dark:odd:bg-gray-800 dark:even:bg-gray-700 dark:hover:bg-gray-600">
                          <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                            <p class="text-theme-sm text-gray-700 dark:text-gray-400">
                              {{ note.created_at | date: 'dd/MM/yyyy HH:mm' }} by {{ note.created_by_username }}
                            </p>
                          </td>
                          <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                            <p [innerHtml]="note.note" class="text-theme-sm text-gray-700 dark:text-gray-400">
                            </p>
                          </td>
                          <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                            <button (click)="updateNote(note.id)" class="text-gray-500 hover:text-primary-500 dark:text-gray-400 dark:hover:text-primary-500">
                              <lucide-icon [size]="20" [name]="EditIcon"></lucide-icon>
                            </button>
                          </td>
                          <td class="border-r border-gray-100 px-4 py-3 dark:border-gray-800">
                            <button (click)="deleteNote(note.id)" class="text-gray-500 hover:text-error-500 dark:text-gray-400 dark:hover:text-error-500">
                              <lucide-icon [size]="20" [name]="TrashIcon"></lucide-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              }

              @if (!showNoteForm) {
                <div class="w-full mt-3 flex justify-end gap-3">
                  <app-button [label]="'Add Note'" (click)="showNoteForm = true"></app-button>
                </div>
              }

              @if (noteForm && showNoteForm) {
                <div class="-mx-2.5 mt-5 flex flex-wrap gap-y-5">
                  <div class="w-full px-2.5">
                    @if (editor) {
                      <div class="NgxEditor__Wrapper min-h-40 h-auto">
                        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
                        <ngx-editor
                          [formControl]="noteForm.controls.note"
                          [editor]="editor"
                          [placeholder]="'Type here...'"
                        ></ngx-editor>
                      </div>
                    }
                  </div>
                  <div class="w-full mt-3 flex justify-end gap-3">
                    <app-button [label]="'Cancel'" [disabled]="processingNote" [style]="'secondary'" (click)="cancelNote()"></app-button>
                    <app-button [label]="editNoteId ? 'Update Note' : 'Save Note'" [disabled]="processingNote || !noteForm.valid || noteForm.pristine"
                                (click)="saveNote()"></app-button>
                  </div>
                </div>
              }

              <app-modal
                [title]="'Delete Note'"
                [content]="'Are you sure you want to delete this note?'"
                [show]="isDeleteModalOpen"
                [closeButtonLabel]="'Cancel'"
                [confirmButtonLabel]="'Yes, Proceed'"
                (onClose)="isDeleteModalOpen = false"
                (onConfirm)="confirmDelete()"
              ></app-modal>
            </div>
          </div>
        } @else {
          <div class="mb-3 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
              <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
                Notes
              </h3>
            </div>
            <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
              <p class="text-gray-500 dark:text-gray-400">Please save the contact to add notes.</p>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="w-full mt-3 flex justify-end gap-3">
      <app-button [label]="'Cancel'" [disabled]="processing" [style]="'secondary'" (click)="cancel()"></app-button>
      <app-button [label]="'Save'" [disabled]="processing || !form.valid || form.pristine" [icon]="SaveIcon" (click)="save()"></app-button>
    </div>

  </form>
</div>
